/**
 * @file Individual Photo Warning Modal.
 */

import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../global/modal/withModal';
import { INDIVIDUAL_PHOTO_NOTICE_MODAL } from '../../constants/modals';
import Button from '../global/Button';
import { getAsset } from '../../util/assets';

const propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};

const IndividualPhotoWarningModal = ({ onRequestClose }) => (
  <div className="p-1">
    <div className="mt-2 text-center">
      <h4>Please select a photo</h4>
      <img
        className="ppd-checkout-example-img"
        src={getAsset('/ppd-checkbox-example.png')}
        alt=""
      />
      <p className="text-sm mt-2">
        Tap on the checkmark on each photo to view individual photo purchasing
        options.
      </p>
      <Button btnBlock btnStyle="link" onClick={onRequestClose}>
        Got it!
      </Button>
    </div>
  </div>
);

IndividualPhotoWarningModal.propTypes = propTypes;

export default withModal(IndividualPhotoWarningModal, {
  name: INDIVIDUAL_PHOTO_NOTICE_MODAL,
  size: 'sm',
  hideHeader: true,
});
